import {
  EnterpriseMemberInvitationStatus,
  ENTERPRISE_MEMBER_INVITATION_STATUS,
} from 'models/Enterprises';
import { ENTERPRISE_BUSINESS_UNIT } from '../../../../../Portfolio/components/PortfolioSellerFilters/data';

export const SENIORITY = 'enterpriseSeniorityId';

export const BROKER_STATUS = 'invitationStatus';

export const FILTERS = [ENTERPRISE_BUSINESS_UNIT, BROKER_STATUS, SENIORITY];

export const BROKER_STATUS_TRANSLATION: Record<
  EnterpriseMemberInvitationStatus,
  string
> = {
  [ENTERPRISE_MEMBER_INVITATION_STATUS.ACTIVE]: 'active',
  [ENTERPRISE_MEMBER_INVITATION_STATUS.ACCEPTED]: 'accepted',
  [ENTERPRISE_MEMBER_INVITATION_STATUS.INVITATION_SENT]: 'sent',
  [ENTERPRISE_MEMBER_INVITATION_STATUS.NOT_INVITED]: 'unsent',
} as const;
